<template>
  <div class="container-fluid grayed-offset">
    <div class="container-fixed">
      <VTest custom-class="row aligncontent" :default-test="defaultTest" :test-diffs="testDiffs" i18n="substore">
        <template #header>
          <div class="col-l-12">
            <h1>Product Component Test-Suite:</h1>
          </div>
        </template>

        <template #item="{ test, n, toggle }">
          <VProduct v-bind="test" />
          <div class="col-l-6 col-m-12">
            <div class="tile">
              <h3
                >Test #{{ n }}: <small>{{ test.description }}</small></h3
              >
              <a href="#" style="position: relative; top: 16px; font-size: 10pt;" @click.prevent="$set(toggle, n, !toggle[n])">Toggle details</a>
              <pre v-if="toggle[n]">{{ JSON.stringify(test, null, 2) }}</pre>
            </div>
          </div>
        </template>

        <template #toggle><VEmpty /></template>

        <template #separator><VEmpty /></template>

        <template #sandbox="{ customObject }">
          <div class="row aligncontent">
            <VProduct v-bind="customObject" />
          </div>
        </template>
      </VTest>
    </div>
  </div>
</template>

<script>
import VTest from '@/components/Test';
import VEmpty from '@/components/Empty';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'ProductTest',

  components: {
    VTest,
    VEmpty,
    VProduct: () => import('@/components/Substore/Product'),
  },

  data() {
    return {
      defaultTest,
      testDiffs,
    };
  },
};
</script>
